module.exports = __webpack_public_path__ + "img/43.79ab1f13.png";